	<template>
		<input class="calculator__input" :pattern="pattern" :class="classes" v-model="m" :step="step" :id="id" :aria-label="label" type="number" :min="min" :max="max" @change="eventChange()" @blur="eventBlur(value)">  
	</template>

	<script>
	export default {
		name: "InputNumberElement",
		props: {
			label: String,
			id: String,
			min: String,
			max: String,
			decimal: {
				type: Boolean,
				default: false
			},
			step: Number,
			classes: Object,
			pattern: String,
			value: Number
		},
		methods: {
			eventBlur() {
				this.$emit("blur");
			},
			eventChange() {
				this.$emit("change");
			}
		},
		computed: { 
			m : {
				get() {
					return parseFloat(this.value);
				}, 
				set(value) {
					this.$emit('input', parseFloat(value));
				}
			}
		}
	};
	</script>